// The person's actions that need desyr ID when its own session is over (36-desyr-id.md, Behaviour 1.4,
// v1.58.70): every press whose request carries the ID token goes to desyr ID's sign-in in this window
// once and comes back to the same page; the press isn't replayed (the person presses again), except a
// circle switch, which goes on by itself (Behaviour 6.4). Background calls never come here.
import { config } from '../core/config';
import { startSignIn } from './oidc';

/** desyr ID's own session is over: the refresh token refused, or a sign-in from before a recovery's cutoff. */
export const sessionOver = (e: unknown) => {
  const { status, code } = (e ?? {}) as { status?: number; code?: string };
  return status === 401 && code === 'desyr.id.sign_in';
};

const ROUND = 'desyr_id_round';
/** One round trip per tab: true when none went in the last 2 minutes, and this one is noted; back still refused, no second. */
export function roundTrip(now = Date.now()): boolean {
  try {
    if (now - (Number(sessionStorage.getItem(ROUND)) || 0) < 2 * 60_000) return false;
    sessionStorage.setItem(ROUND, String(now));
    return true;
  } catch {
    return false; // storage refused: never a loop
  }
}
/** Through again: a later end of the session may sign in again. */
export function roundDone(): void {
  try {
    sessionStorage.removeItem(ROUND);
  } catch {
    // storage refused
  }
}

/** desyr ID's sign-in in this window, back at this page (`keep`: what to note for it first); never resolves. */
export async function signInFor(e: unknown, keep?: () => void): Promise<never> {
  keep?.();
  await startSignIn(config().desyrId!, location.pathname + location.search).catch(() => {
    throw e;
  });
  return new Promise<never>(() => {}); // the window goes
}

/** A pressed call that carries the ID token: when desyr ID's session is over, its sign-in once (see above). */
export async function pressed<T>(call: () => Promise<T>, keep?: () => void): Promise<T> {
  try {
    const answer = await call();
    roundDone();
    return answer;
  } catch (e) {
    if (sessionOver(e) && roundTrip()) return signInFor(e, keep);
    throw e;
  }
}
